<script setup lang="ts">
// import { debounce } from "@/assets/js/helpers";

// const prpos =
// defineProps<{
// 	searchValue: string | number;
// 	placeholder: string;
// }>();

const props = withDefaults(
	defineProps<{
		searchValue: string | number;
		placeholder: string;
		inputStyle?: any;
		addTimeout?: boolean;
	}>(),
	{
		addTimeout: true,
		inputStyle: "",
	},
);

const emit = defineEmits(["update:searchValue", "search"]);

// const handleInput = debounce(
// 	function (evt: Event) {
// 		emit("update:searchValue", (evt.target as HTMLInputElement).value);
// 	},
// 	300,
// 	false,
// );
// use
// @input="handleInput"

const date = ref<any>(null);
function keyUp(evt: Event) {
	// console.log(Date.now())
	date.value = Date.now();
	if (props.addTimeout) {
		setTimeout(() => {
			if (date.value + 1000 <= Date.now()) {
				// console.log("true - " + prpos.searchValue);
				emit("update:searchValue", (evt.target as HTMLInputElement).value);
				emit("search", (evt.target as HTMLInputElement).value);
			} else {
				// console.log("ne - " + prpos.searchValue);
			}
			// console.log(date.value + " " + Date.now());
		}, 1000);
	} else {
		emit("update:searchValue", (evt.target as HTMLInputElement).value);
		emit("search", (evt.target as HTMLInputElement).value);
	}
}
</script>
<template>
	<div class="search-wrapper">
		<div class="img-wrap-search">
			<img
				src="@/assets/image/icons/search.svg"
				alt=""
			/>

			<!-- <i class="fa fa-search"></i> -->
		</div>
		<input
			:value="props.searchValue"
			type="text"
			:placeholder="props.placeholder"
			:style="inputStyle"
			@keyup="keyUp"
			@input="keyUp"
		/>
	</div>
</template>
<style scoped lang="scss">
.search-wrapper {
	position: relative;
	min-width: 150px;
	i.fa.fa-search,
	img {
		position: absolute;
		// top: 11px;
		top: 11px;
		bottom: 11px;
		// left: 14px;
		right: 10px;
		// display: flex;
		// align-items: center;

		// &::before {
		// 	max-width: 10px;
		// 	max-height: 10px;
		// }
	}

	input {
		padding-left: 24px;
		padding-right: 24px !important;
		font-size: 12px;
		width: 100%;
	}
}
</style>
